// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".practitioners-video__frame[data-v-57905f5f]{width:100%}@media(min-width:992px)and (max-width:99999px){.practitioners-video__frame[data-v-57905f5f]{height:668px}}@media(min-width:768px)and (max-width:991px){.practitioners-video__frame[data-v-57905f5f]{height:700px}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
